import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute , ParamMap} from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../../services/common-data.service';
import { CommerceDataService } from '../../../services/commerce-data.service';
import { environment } from '../../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-mark-sale-asready-forcollection',
  templateUrl: './mark-sale-asready-forcollection.component.html',
  styleUrls: ['./mark-sale-asready-forcollection.component.css']
})
export class MarkSaleAsreadyForcollectionComponent implements OnInit {

  modelForm: FormGroup;
  modelData;
  orderRef = "";
  orderStatus = ""
  userId
  saleId 
  orderId
  saleItems = []

  subscription;
  queryParams
  modelReady = false;
  shippmentQuoteRef;

  //mapbox search stuff
  searchForm: FormGroup;
  selectedAddress = [];
  addresses = [];

  query: any;
  showResults = false;
  loading = false;
  doneSearch = false;
  formDetected = false;

  addressObjects = []
  actionAccept = false;
  shippingCost = 0;
  
  selectedAction = "collect";

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private route: ActivatedRoute,
    private _ecomm: CommerceDataService
  ) { }

  ngOnInit() {

    this.initialiseForm()
    this.queryParams = this._data.queryParams;

    //lets create a subscription of 
    this.subscription = this._data.queryParamsChanged.subscribe(
      (data) => {
        this.queryParams = data;

        if(this.queryParams.saleId != undefined) {
            
            $('#loader').show();

            this.saleId = this.queryParams.saleId;

            this.userId = sessionStorage.getItem('context')
            this.shippingCost = 0;
            this.selectedAddress = [];
            this.addresses = [];

            this.showResults = false;
            this.loading = false;
            this.doneSearch = false;
            this.formDetected = false;

            this.addressObjects = []
            this.actionAccept = false;
            this.selectedAction = "collect";

            this.modelData = [];
            this.orderStatus = "";
            this.orderRef = "";
            this.saleItems = [];
            this.modelReady = false;

            if(!this.userId && !this.saleId) {
                $('#loader').hide();
                // redirect to login 
                // return false;
            }

            else {
              // this.calculateShippingCostFromWarehouseToPackagingCenter()
              this.getSaleDetails()
            }
        }
        
      }
    );
  }

  initialiseForm() {
    this.modelForm = this.formBuilder.group({
      // building: ['', Validators.required],
      shipping_required: [true],
      shipping_not_required: [false],
      lat: ['', Validators.required],
      lng: ['', Validators.required],
      fullAddress: ['', Validators.required],
      ObjectString: ['', Validators.required],
      delivery_post_code: ['', Validators.required],
      delivery_city: ['', Validators.required]

    });
  }

  getSaleDetails() {

    let queryData = new FormData();
    queryData.append('modelName', 'Sale');
    queryData.append('mid', this.saleId);
    queryData.append('context_id', this.userId);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          this.modelData = data['covers'][0]['cover']['model']['modelData'];
          this.orderStatus = this.modelData['systemManagedEntities']['saleDetails']['collectionFromSellerStatus'];
          this.orderRef = this.modelData['systemManagedEntities']['saleDetails']['transactionRef'];
          this.orderId = this.modelData['systemManagedEntities']['saleDetails']['orderId'];
          this.saleItems = this.modelData['systemManagedEntities']['saleDetails']['items'];
          this.modelReady = true;

        },
        error => {

            $('#loader').hide();

        },

        () => {
          $('#loader').hide();
          // this.reviewOrderSummary()
        }
      );
  }

  search(event, i) {
    this.query = event.target['value'];
    this.showResults = true;
    this.loading = true;
  
    if (this.query.length > 2) {
      var formData = new FormData();
      formData.append('search_term', this.query)
      formData.append('limit', '10')
      formData.append('country', 'za')
  
      this._data.getAddress(formData).subscribe(
        data => {
        this.addresses[i] = data.data['addresses']
        //console.log('addresses are is: '+JSON.stringify(this.addresses))
        // this.scrollToBottom();
        },
        err => {
          console.log('error')
        },
        () => {}
      );
      this.loading = false;
    }
  }
  
  addressSelect (fullAddress, lat, lng, address, i) {
  
    alert(fullAddress)
    this.showResults = false;
    // this.doneSearch = true;
    // this.searchForm.get('searchable').disable();
    this.selectedAddress[i] = fullAddress;
    this.modelForm.get('lat').setValue(lat);
    this.modelForm.get('lng').setValue(lng);
    this.modelForm.get('fullAddress').setValue(fullAddress);
    this.modelForm.get('ObjectString').setValue(JSON.stringify(address));
    this.modelForm.get('delivery_post_code').setValue(address.postCode);
    this.modelForm.get('delivery_city').setValue(address.town);
  }
  
  searchResetOnBackspace (event, i) {
    if (event.keyCode === 8 && this.selectedAddress[i]) { // if you hit backspace and have already selected a result, reset
        console.log('cleansed!');
        this.selectedAddress[i] = event.target['value'];
        this.search(event, i); // repopulate results
    }
  };

  toggleDeliveryAction(actionRequired) {

    if(actionRequired == 'collect') {
      this.modelForm.get('shipping_required').setValue(true);
      this.modelForm.get('shipping_not_required').setValue(false);
      this.actionAccept = false;
      this.selectedAction = "collect";
    }

    else if(actionRequired == 'deliver') {
      this.modelForm.get('shipping_required').setValue(false);
      this.modelForm.get('shipping_not_required').setValue(true);
      this.actionAccept = true;
      this.selectedAction = "deliver";
    }

  }

  calculateShippingCostFromWarehouseToPackagingCenter() {
    //use sale if to calculate shipping cost for moving products from warehouse
    if(this.shippingCost == 0) {

      let mid = this.saleId

      if(this.modelForm.invalid) {
        //show form error
        let h = {
          class: "iziToast-warning",
          title:  "Error:",
          message:  "Please specify a valid address!",
          animateInside: !1,
          position: "topRight",
          progressBar: !1,
          icon: "icon-bell",
          timeout: 3200,
          transitionIn: "fadeInLeft",
          transitionOut: "fadeOut",
          transitionInMobile: "fadeIn",
          transitionOutMobile: "fadeOut",
        };
        iziToast.show(h);

        return true;
      }

      let queryData = new FormData();
      queryData.append('id', this.modelData['systemManagedEntities']['saleDetails']['orderId']);
      queryData.append('lat', this.modelForm.controls['lat'].value);
      queryData.append('lng', this.modelForm.controls['lng'].value);
      queryData.append('fullAddress', this.modelForm.controls['fullAddress'].value);
      queryData.append('delivery_post_code', this.modelForm.controls['delivery_post_code'].value);
      queryData.append('delivery_city', this.modelForm.controls['delivery_city'].value);

      $('#loader').show();

      this._data.dynamicFormPost(queryData, 'courier-stock-delivery-quote') 
        .pipe(first())
        .subscribe(
          data => {
            console.log(data);

              // alert(data['quote']['methodId']['fee']);
              this.shippingCost = data['quote']['shippingCost'];
              this.shippmentQuoteRef = data['quote']['waybillQuoteDetails']['model']['modelData']['systemManagedEntities']['parcelDetails']['quoteReference'];
              this.actionAccept = true;

          },
          error => {
              $('#loader').hide();
          },

          () => {
              $('#loader').hide();
          }
      );
    }

  }

  onSubmit() {
    //send the form post to the mark order as complete endpoint
    if(this.selectedAction ==  "deliver") {
      this.markOrderAsReadySellerToDeliver()
    }

    else if (this.selectedAction ==  "collect") {

      if(this.modelForm.invalid) {
        //show form error
        let h = {
          class: "iziToast-warning",
          title:  "Error:",
          message:  "Please specify a valid address!",
          animateInside: !1,
          position: "topRight",
          progressBar: !1,
          icon: "icon-bell",
          timeout: 3200,
          transitionIn: "fadeInLeft",
          transitionOut: "fadeOut",
          transitionInMobile: "fadeIn",
          transitionOutMobile: "fadeOut",
        };
        iziToast.show(h);

        return true;
      }

      this.markOrderAsReadyAndAcceptInternalCourierShipping()
    }
  }

  getPackagingDeliveryAddress() {
    return "76 Besembos, Amandasig, Pretoria. 0182"
  }

  markOrderAsReadyAndAcceptInternalCourierShipping() {
    //
    $('#loader').show();

      this._data.dynamicFormPost({waybillQuoteRef: this.shippmentQuoteRef, saleId: this.saleId, backOrderRef: this.orderId}, 'mark-seller-order-ready-collect') 
        .pipe(first())
        .subscribe(
          data => {
            console.log(data);

            let h = {
              class: "iziToast-info",
              title:  "Success:",
              message:  "Your order details updated successfuly",
              animateInside: !1,
              position: "topRight",
              progressBar: !1,
              icon: "icon-bell",
              timeout: 3200,
              transitionIn: "fadeInLeft",
              transitionOut: "fadeOut",
              transitionInMobile: "fadeIn",
              transitionOutMobile: "fadeOut",
            };
            iziToast.show(h);

            $("#closeMarkSaleAsReady").trigger("click");

          },
          error => {
              $('#loader').hide();
          },

          () => {
              $('#loader').hide();
          }
      );
  }

  markOrderAsReadySellerToDeliver() {
    //mark-seller-order-ready-self-deliver

    $('#loader').show();

      this._data.dynamicFormPost({backOrderRef: this.orderId, saleId: this.saleId}, 'mark-seller-order-ready-self-deliver') 
        .pipe(first())
        .subscribe(
          data => {
            console.log(data);

            let h = {
              class: "iziToast-info",
              title:  "Success:",
              message:  "Your order details updated successfuly",
              animateInside: !1,
              position: "topRight",
              progressBar: !1,
              icon: "icon-bell",
              timeout: 3200,
              transitionIn: "fadeInLeft",
              transitionOut: "fadeOut",
              transitionInMobile: "fadeIn",
              transitionOutMobile: "fadeOut",
            };
            iziToast.show(h);

            $("#closeMarkSaleAsReady").trigger("click");

          },
          error => {
              $('#loader').hide();
          },

          () => {
              $('#loader').hide();
          }
      );
  }

}
